import type { TagIntent } from '@omnipresentgroup/design-system';
import {
  EmploymentStatus,
  type EmploymentStatusMap,
} from '@omnipresentgroup/types';

export const EmploymentStatusIntentMap: { [key: string]: TagIntent } = {
  [EmploymentStatus.CREATED]: 'warning',
  [EmploymentStatus.ONBOARDED]: 'info',
  [EmploymentStatus.ACTIVE]: 'success',
  [EmploymentStatus.INACTIVE]: 'error',
};

export type EmploymentStatusType = (typeof EmploymentStatusMap)[number];
